// `Intl.format` throws a RangeError on an unparseable date, which takes down the whole render,
// so every date formatter here goes through this and falls back to its own placeholder.
function toDate(value) {
  if (!value) {
    return null
  }

  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

export function formatDate(value) {
  const date = toDate(value)
  if (!date) {
    return '—'
  }

  return new Intl.DateTimeFormat('ru-RU', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date)
}

// The news views format dates in en-US with their own field set, so they get a separate export
// instead of being switched to `formatDate`, which would change how every feed date reads.
export function formatNewsDate(value) {
  const date = toDate(value)
  if (!date) {
    return '—'
  }

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)
}

export function formatArmoryTimestamp(value) {
  const date = toDate(value)
  return date ? date.toLocaleString() : 'an unknown time'
}

export function formatNumber(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '—'
  }

  return new Intl.NumberFormat('ru-RU').format(Number(value))
}

export function formatScore(value) {
  if (value === null || value === undefined) {
    return '—'
  }

  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(Number(value))
}

export function formatDuration(milliseconds) {
  if (!milliseconds && milliseconds !== 0) {
    return '—'
  }

  const totalSeconds = Math.floor(milliseconds / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return `${minutes}:${String(seconds).padStart(2, '0')}`
}

export function parseCharacterUrl(url) {
  try {
    const parsed = new URL(url)
    const parts = parsed.pathname.split('/').filter(Boolean)

    if (parts.length < 4 || parts[0] !== 'characters') {
      throw new Error('The URL does not look like a Raider.io character URL')
    }

    const [, region, realm, ...nameParts] = parts
    const name = decodeURIComponent(nameParts.join('/'))

    return { region, realm, name }
  } catch (error) {
    throw new Error('Unable to parse the character URL')
  }
}

export function summarizeRaidProgress(profile) {
  const progression = profile.raid_progression || {}
  return Object.entries(progression)
    .map(([slug, item]) => ({
      slug,
      summary: item.summary,
      mythic: item.mythic_bosses_killed,
      heroic: item.heroic_bosses_killed,
      normal: item.normal_bosses_killed,
      total: item.total_bosses,
    }))
    .sort((left, right) => right.mythic - left.mythic || right.heroic - left.heroic)
}

export function getBestMythicScore(profile) {
  const seasonEntry = profile.mythic_plus_scores_by_season?.[0]
  return seasonEntry?.scores?.all || 0
}
